<template>
  <q-dialog v-model="show_img" maximized transition-show="slide-up" transition-hide="slide-down"
    @click="show_img = false">

    <q-card class="bg-primary text-white">
      <q-img src="img/simple_data.png" />
      <q-bar>
        <q-space />

        <q-btn dense flat icon="minimize" @click="maximizedToggle = false" :disable="!maximizedToggle">
          <q-tooltip v-if="maximizedToggle" class="bg-white text-primary">Minimize</q-tooltip>
        </q-btn>
        <q-btn dense flat icon="crop_square" @click="maximizedToggle = true" :disable="maximizedToggle">
          <q-tooltip v-if="!maximizedToggle" class="bg-white text-primary">Maximize</q-tooltip>
        </q-btn>
        <q-btn dense flat icon="close" v-close-popup>
          <q-tooltip class="bg-white text-primary">Close</q-tooltip>
        </q-btn>
      </q-bar>

      <q-card-section>
        <div class="text-h6">Alert</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <q-img class="z-index=9999" :src="current_img" @click="show_img = false" />
      </q-card-section>
    </q-card>

    <q-card>
      {{ current_img }}
      <img src="img/base_data.png" @click="show_img = false" />
    </q-card>
  </q-dialog>

  <q-splitter v-model="splitterModel">
    <template v-slot:before>
      <q-tabs v-model="innerTab" vertical class="text-primary">
        <q-tab name="innerSimpleData" label="简单数据" />
        <q-tab name="innerBaseDdata" label="基础数据" />
        <q-tab name="innerReceipt" label="单据录入" />
        <q-tab name="innerChooseReceipt" label="选择单据录入" />
        <q-tab name="innerReport" label="报表" />
      </q-tabs>
    </template>

    <template v-slot:after>
      <q-tab-panels v-model="innerTab" animated transition-prev="slide-down" transition-next="slide-up">
        <q-tab-panel name="innerSimpleData">
          <div class="text-h5 q-mb-md">简单数据</div>
          <p>处理一些简单的数据或者具有分层级的数据。适用于：货品分类，单位，结算方式等</p>
          <p>
            <q-img src="./img/simple_data.png" style="max-width: 1000px;" :fit="img_fit">
              <div class="absolute-bottom text-subtitle1 text-center">
                数据搜索/展示/编辑
              </div>
            </q-img>
          </p>
        </q-tab-panel>

        <q-tab-panel name="innerBaseDdata">
          <div class="text-h5 q-mb-md">基础数据</div>
          <p>基础数据比简单数据提供更多的查询条件，可以对数据进行审核，导入，导出，打印等。适用于：货品资料，供应商资料，客户资料等</p>
          <p>
            <q-img src="./img/base_data1.png" style="max-width: 1000px;" :fit="img_fit">
              <div class="absolute-bottom text-subtitle1 text-center">
                数据搜索及展示
              </div>
            </q-img>
          </p>

          <p>
            <q-img src="./img/base_data2.png" style="max-width: 1000px;" :fit="img_fit">
              <div class="absolute-bottom text-subtitle1 text-center">
                数据编辑
              </div>
            </q-img>
          </p>
        </q-tab-panel>

        <q-tab-panel name="innerReceipt">
          <div class="text-h5 q-mb-md">单据录入</div>
          <p>分为表头数据和明细数据的资料，具体审核，反审，导入，导出，打印等功能。适用于：采购订单，销售订单等</p>
          <p>
            <q-img src="./img/receipt1.png" style="max-width: 1000px;" :fit="img_fit">
              <div class="absolute-bottom text-subtitle1 text-center">
                数据搜索及展示
              </div>
            </q-img>
          </p>

          <p>
            <q-img src="./img/receipt2.png" style="max-width: 1000px;" :fit="img_fit">
              <div class="absolute-bottom text-subtitle1 text-center">
                数据编辑
              </div>
            </q-img>
          </p>
        </q-tab-panel>
        <q-tab-panel name="innerChooseReceipt">
          <div class="text-h5 q-mb-md">选择单据录入</div>
          <p>在单据录入的基础上增加选择其他单据数据进行录入，避免资料重复录入的重要手段。例如：采购入库（选择采购订单明细数据），销售出库（选择销售订单明细数据），客户对账单（选择销售出库明细数据）等</p>
          <p>
            <q-img src="./img/choose_receipt1.png" style="max-width: 1000px;" :fit="img_fit">
              <div class="absolute-bottom text-subtitle1 text-center">
                数据搜索及展示
              </div>
            </q-img>
          </p>

          <p>
            <q-img src="./img/choose_receipt2.png" style="max-width: 1000px;" :fit="img_fit">
              <div class="absolute-bottom text-subtitle1 text-center">
                数据编辑
              </div>
            </q-img>
          </p>

          <p>
            <q-img src="./img/choose_receipt3.png" style="max-width: 1000px;" :fit="img_fit">
              <div class="absolute-bottom text-subtitle1 text-center">
                选择相关数据
              </div>
            </q-img>
          </p>
        </q-tab-panel>
        <q-tab-panel name="innerReport">
          <div class="text-h5 q-mb-md">报表</div>
          <p>用已录入的数据整理出符合要求的相关报表，可按指定格式进行打印，导出。</p>
          <p>
            <q-img src="./img/report.png" style="max-width: 1000px;" :fit="img_fit">
              <div class="absolute-bottom text-subtitle1 text-center">
                数据搜索及展示/其他功能
              </div>
            </q-img>
          </p>
        </q-tab-panel>
      </q-tab-panels>
    </template>

  </q-splitter>

  <!-- <q-list bordered>
    <q-expansion-item switch-toggle-side header-class="bg-primary text-white" label="菜单模板介绍（点击展开/隐藏）" default-close>
      <div class="col-12">
        <div class="q-pa-md">
          <q-carousel swipeable animated arrows v-model="slide" v-model:fullscreen="fullscreen" infinite autoplay
            control-type="unelevated" control-color="grey-5" control-text-color="white"> -->
  <!-- <q-carousel-slide :name="1" img-src="./img/simple_data.png"
              @click="current_img = './img/simple_data.png'; show_img = true;">
              <div class="absolute-bottom custom-caption">
                <div class="text-h5 text-weight-bolder">简单数据</div>
                <div class="text-subtitle1">处理一些简单的数据或者具有分层级的数据。适用于：货品分类，单位，结算方式等</div>
              </div>
            </q-carousel-slide>

            <q-carousel-slide :name="2" img-src="./img/base_data.png" @click="show_img = true;">
              <div class="absolute-bottom custom-caption">
                <div class="text-h5 text-weight-bolder">基础数据</div>
                <div class="text-subtitle1">
                  基础数据比简单数据提供更多的查询条件，可以对数据进行审核，导入，导出，打印等。适用于：货品资料，供应商资料，客户资料等
                </div>
              </div>
            </q-carousel-slide>

            <q-carousel-slide :name="3" img-src="./img/receipt.png"
              @click="current_img = 'img/receipt.png'; show_img = true;">
              <div class="absolute-bottom custom-caption">
                <div class="text-h5 text-weight-bolder">单据录入</div>
                <div class="text-subtitle1">分为表头数据和明细数据的资料，具体审核，反审，导入，导出，打印等功能。适用于：采购订单，销售订单等</div>
              </div>
            </q-carousel-slide>

            <q-carousel-slide :name="4" img-src="./img/report.png"
              @click="current_img = './img/report.png'; show_img = true;">
              <div class="absolute-bottom custom-caption">
                <div class="text-h5 text-weight-bolder">选择单据录入</div>
                <div class="text-subtitle1">
                  在单据录入的基础上增加选择其他单据数据进行录入，避免资料重复录入的重要手段。例如：采购入库（选择采购订单明细数据），销售出库（选择销售订单明细数据），客户对账单（选择销售出库明细数据）等
                </div>
              </div>
            </q-carousel-slide>

            <q-carousel-slide :name="5" img-src="./img/report.png"
              @click="current_img = './img/report.png'; show_img = true;">
              <div class="absolute-bottom custom-caption">
                <div class="text-h5 text-weight-bolder">报表</div>
                <div class="text-subtitle1">用已录入的数据整理出符合要求的相关报表，可按指定格式进行打印，导出。</div>
              </div>
            </q-carousel-slide> -->






  <!-- <template v-slot:control>
                    <q-carousel-control position="bottom-right" :offset="[18, 18]">
                      <q-btn push round dense color="white" text-color="primary" @click="fullscreen = !fullscreen">
                        <q-icon :name="fullscreen ? 'fas fa-compress' : 'fas fa-expand'" />
                      </q-btn>
                    </q-carousel-control>
                  </template> -->



  <!-- </q-carousel>
        </div>
      </div>
    </q-expansion-item>
  </q-list> -->
</template>

<script>
import { useQuasar } from "quasar";
import { request } from "@/request/api";
import { useI18n } from "vue-i18n";
import { ref, watch } from "vue";
import { fasFont } from '@quasar/extras/fontawesome-v5'

export default {
  name: 'Rotation',
  setup() {
    const slide = ref(1);
    const fullscreen = ref(false);

    const show_img = ref(false);

    return {
      slide,
      fullscreen,
      show_img,


      innerTab: ref('innerSimpleData'),
      splitterModel: ref(20),
      img_fit: "contain",
    }
  }
}
</script>

<style scoped>
.custom-caption {
  text-align: center;
  padding: 12px;
  color: white;
  background-color: rgba(0, 0, 0, .3)
}

.expansion-header {
  background-color: rgb(117, 148, 252);
  color: #fff;
}
</style>